import { useInitMyClientUser } from 'client-app/hooks/use-init-my-client-user';
import { Router } from 'client-app/router/client-router';
import 'client-app/client-app.scss';

const ClientApp = () => {
  const { isLoading } = useInitMyClientUser();

  if (isLoading) return <div />;

  return <Router />;
};

export default ClientApp;
